import { Routes, Route } from "react-router";
import Dashboard from "./pages/Dashboard";

/**
 * Gateway routes - AI Gateway proxy management
 * Protected by AdminGuard (admin role only)
 */
export default function GatewayRoutes() {
  return (
    <Routes>
      <Route index element={<Dashboard />} />
      <Route path="dashboard" element={<Dashboard />} />
    </Routes>
  );
}
